import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import App from './App';
import './index.css';
import { prefetchCommon } from './lib/openai/speedOptimizer';
import { CookieConsent } from './components/common/CookieConsent';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from './context/AuthContext';

// Warm up the cache with common requests in the background
setTimeout(() => {
  prefetchCommon();
}, 2000); // Wait 2 seconds after app loads

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <CookieConsent />
        <Toaster />
        <Analytics />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);